export const ROLE_IDS = [
  "spark",
  "care",
  "steady",
  "warmth",
  "idea",
  "roam",
] as const;

export type RoleId = (typeof ROLE_IDS)[number];

export interface RoleDefinition {
  id: RoleId;
  name: string;
  description: string;
  color: string;
  image: string;
}

export const ROLES: readonly RoleDefinition[] = [
  {
    id: "spark",
    name: "氛围点亮者",
    description: "让陌生场合自然热起来",
    color: "#F2A69B",
    image: "/roles/spark.png",
  },
  {
    id: "care",
    name: "细节守护者",
    description: "记得别人容易忽略的小事",
    color: "#BFD58C",
    image: "/roles/care.png",
  },
  {
    id: "steady",
    name: "稳稳推进者",
    description: "把想法变成真正发生的事",
    color: "#F0CE63",
    image: "/roles/steady.png",
  },
  {
    id: "warmth",
    name: "温柔接住者",
    description: "朋友有情绪时最愿意找的人",
    color: "#E7AAC3",
    image: "/roles/warmth.png",
  },
  {
    id: "idea",
    name: "灵感制造者",
    description: "带来新点子和好玩的记录",
    color: "#A9C6EB",
    image: "/roles/idea.png",
  },
  {
    id: "roam",
    name: "自在探索者",
    description: "面对变化仍然享受过程",
    color: "#9ED4CD",
    image: "/roles/roam.png",
  },
] as const;

export const ROLE_BY_ID = Object.fromEntries(
  ROLES.map((role) => [role.id, role]),
) as Record<RoleId, RoleDefinition>;

export function isRoleId(value: unknown): value is RoleId {
  return typeof value === "string" && ROLE_IDS.includes(value as RoleId);
}
